import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'

Vue.config.productionTip = false

// Captura o evento de instalação globalmente, independentemente da rota atual
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  window.deferredPromptEvent = e;
});

import './plugin/axios'
import store from "./store";

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/css/modern-design.css' 
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

import ToggleButton from 'vue-js-toggle-button'
Vue.use(ToggleButton)

import VueSimpleAlert from "vue-simple-alert";
Vue.use(VueSimpleAlert);

import VueLoading from 'vuejs-loading-plugin';
Vue.use(VueLoading, {
  dark: true, // default false
  text: 'Carregando...', // default 'Loading'
})

import 'vue-search-select/dist/VueSearchSelect.css'

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
